import { CreditCard } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { CreatePaymentNodeData } from '@repo/shared-types';

export const CreatePaymentNode = ({
  data,
  selected,
}: {
  data: CreatePaymentNodeData;
  selected?: boolean;
}) => (
  <NodeShell
    type="create_payment"
    icon={<CreditCard size={16} />}
    label={data.label}
    subtitle={
      [data.amount ? `£${data.amount}` : 'default fee', data.markAsSent ? 'mark sent' : null]
        .filter(Boolean)
        .join(' · ') || undefined
    }
    selected={selected}
  />
);
